import { Button, Card, CardContent, Grid, IconButton, Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSSelectField from "../../Components/Select/WSSelect";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import WSDateField from "../../Components/DateField/WSDateField";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import WSButton from "../../Components/Button/WSButton";

export const OtherIncome:React.FC<any>=React.memo((props)=>{
    const { control, register, handleSubmit, setValue, reset } = useForm<any>();
      const navigate = useNavigate();
      const { fields, append, remove, replace } = useFieldArray({
          name: "items",
          control,
        });
    
          const handleData = async (data: any) => {
        debugger;
        console.log("onsubmit===>", data); // You can perform any action with the submitted data here
      };
    
    
      const handleClose = () => {
        navigate("/");
      };
     const [showExtraFields, setShowExtraFields] = useState(false);
        const genId = () => Date.now().toString(36) + Math.random().toString(36).slice(2);
        const [paymentRows, setPaymentRows] = useState(() => [{ id: genId(), paymentType: '', amount: '' }]);
    
        const handleAddRow = () => setPaymentRows(prev => [...prev, { id: genId(), paymentType: '', amount: '' }]);
        const handleRemoveRow = (idToRemove:any) => setPaymentRows(prev => prev.filter(r => r.id !== idToRemove));
        
    return(
         <form>
      <Card>
        <CardContent>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            wrap="nowrap"
          >
            <Grid item>
              <Grid container spacing={2} alignItems="center" wrap="nowrap">
                <Grid item>
                  <Typography fontWeight="bold" variant="h6">
                    Other Income
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Right side: Close Icon */}
            <Grid item>
              <IconButton onClick={handleClose}>
                <WSIcons.CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
           <Grid container spacing={2} mt={3}>
            <Grid item xs={12} sm={6}>
                <WSSelectField
                rules={{ required: true }}
                control={control}
                id="incomeCategory"
                {...register("incomeCategory")}
                name="incomeCategory"
                label="Income Category"
              />
            </Grid>
              <Grid item xs={12} sm={6}>
              <WSDateField
                id="date"
                name="date"
                label={" Date "}
                dateFormat="DD-MM-YYYY"
                denyFuturOrPast="custom"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            {fields.map((row, index) => (
                          <Grid
                            container
                            spacing={2}
                            key={row.id}
                            alignItems="center"
                            mt={1}
                            ml={1}
                          >
                            <Grid item xs={1.5}>
                              <WSTextField
                                label="Item"
                                {...register(`items.${index}.item`)}
                                id={`item-${index}`}
                                control={control}
                                disabled
                              />
                            </Grid>
                            <Grid item xs={2}>
                              <WSTextField
                                label="QTY"
                                id={`qty-${index}`}
                                {...register(`items.${index}.qty`, {})}
                                control={control}
                              />
                            </Grid>
            
                            <Grid item xs={2}>
                              <WSTextField
                                label="Price/Unit"
                                id={`price-${index}`}
                                {...register(`items.${index}.price`, {})}
                                control={control}
                              />
                            </Grid>
                            <Grid item xs={2}>
                              <WSTextField
                                label="Amount"
                                id={`amount-${index}`}
                                {...register(`items.${index}.amount`, {})}
                                control={control}
                              />
                            </Grid>
                            <Grid item display="flex" justifyContent="center">
                              <WSIcons.DeleteIcon
                                onClick={() => {
                                  remove(index);
                                }}
                                sx={{ color: "red", cursor: "pointer" }}
                              />
                            </Grid>
                          </Grid>
                        ))}
                          <Grid item xs={12} sx={{ marginLeft: 1 }}>
                                      <WSButton
                                        id="addButton"
                                        label="+ Add"
                                        size="small"
                                        onClick={() =>
                                          append({
                                            productId: "",
                                            quantity: "",
                                            unit: "",
                                            unitPrice: "",
                                            total: "",
                                          })
                                        }
                                      />
                                    </Grid>
             <Grid item xs={12} sm={6}>
      {!showExtraFields ? (
        <>
          <WSSelectField
            label="Payment Type"
            rules={{ required: true }}
            {...register("paymentType")}
            id={"paymentType"}
            control={control}
          />
          <Button
            variant="text"
            size="small"
            sx={{ textTransform: "none", p: 0, mt: 1 }}
            onClick={() => setShowExtraFields(true)}
          >
            + Add Payment Details
          </Button>
        </>
      ) : (
        <Paper sx={{ p: 2 }}>
          <Grid container spacing={2}>
          {paymentRows.map((row, index) => (
  <React.Fragment key={row.id}>
    <Grid item xs={12} sm={4}>
      <WSSelectField
        label="Payment Type"
        {...register(`paymentRows.${index}.paymentType`)}
        id={`paymentType-${row.id}`}
        control={control}
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <WSTextField
        label="Amount"
        {...register(`paymentRows.${index}.amount`)}
        id={`amount-${row.id}`}
        control={control}
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <WSIcons.DeleteIcon onClick={() => handleRemoveRow(row.id)} sx={{ cursor: 'pointer' }} />
    </Grid>
  </React.Fragment>
))}

            <Grid item xs={12}>
              <Button
                variant="text"
                size="small"
                sx={{ textTransform: "none", p: 0, mt: 1 }}
                onClick={handleAddRow}
              >
                + Add Payment Type
              </Button>
            </Grid>
          </Grid>
        </Paper>
      )}
    </Grid>
     <Grid item xs={12} sm={6}>
              <WSTextAreaField
                label={"Description"}
                id={"description"}
                name={"description"}
                control={control}
                rules={{ required: false }}
                rows={3}
              />
            </Grid>
           
            <Grid item xs={12} sm={6}>
            <WSImageUpload
              control={control}
              id="image"
              name="image"
              label="Add image"
              rules={{ required: false }}
            />
            </Grid>
             <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Total"}
                {...register("total")}
                id="total"
                name="total"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            
            </Grid>
            </CardContent>
            </Card>
              <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
                    <Grid item>
                      <WSButton
                        id="share"
                        label="Share"
                        size="medium"
                        variant="outlined"
                        color="primary"
                        
                        sx={{
                          borderRadius: 2,
                          border: "1px solid rgba(126, 176, 246, 1)",
                          color: "rgba(126, 176, 246, 1)",
                          backgroundColor: "#FFFFFF",
                        }}
                      />
                    </Grid>
          
                    <Grid item>
                      <WSButton
                        id="submit"
                        type="submit"
                        label="Save"
                        size="medium"
                        variant="outlined"
                        color="primary"
                        onClick={handleSubmit(handleData)}
                        sx={{
                          borderRadius: 2,
                          width: "6rem",
                          border: "1px solid rgba(126, 176, 246, 1)",
                          color: "#FFFFFF",
                          backgroundColor: "rgba(126, 176, 246, 1)",
                          "&:hover": {
                            backgroundColor: "rgba(126, 176, 246, 1)",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
            </form>
    )
})